import { NgxLoggerLevel } from 'ngx-logger';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBE: 'cartellinibe-base',
  apiBEManagement: 'cartellinibe-management',
  apiBEMailingList: 'cartellinibe-mailing-list',
  apiBETask: 'cartellini-task',
  apiNFCcontext: 'cartellini-nfc',
  apiNFCport: 10000,
  apiPrint: 'cartellinibe-print',
  apiCalendar: 'shift-calendar',
  firebase: {
    apiKey: 'AIzaSyBuZIaBDnDv1MTiaQ7X2F70HP9AXU6qbHE',
    authDomain: 'cartellini-f124e.firebaseapp.com',
    databaseURL: 'https://cartellini-f124e.firebaseio.com',
    projectId: 'cartellini-f124e',
    storageBucket: 'cartellini-f124e.appspot.com',
    messagingSenderId: '305326942775',
    appId: '1:305326942775:web:79fed16fb996e5cd996db2'
  },
  authConfig: {
    issuer: 'https://login.microsoftonline.com/213f198d-7e2e-41bc-b335-289df303ae68/v2.0',
    redirectUri: window.location.origin + '/callback',
    clientId: '661f945e-6e89-47aa-bdad-7a09ca3da4b9',
    scope: 'openid profile email api://a9279849-51fb-4d0e-b2db-8e3285dab9ca/access_as_user offline_access',
    strictDiscoveryDocumentValidation: false,
    responseType: 'code',
    oidc: true,
    showDebugInformation: true
  },
  logger: {
    loglevel: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.OFF,
    serverLoggingUrl: '/api/logs'
  },
  serviceWorker: false
};
